import { render } from "./LightboxRetention.vue?vue&type=template&id=802a6e36&scoped=true"
import script from "./LightboxRetention.vue?vue&type=script&lang=js"
export * from "./LightboxRetention.vue?vue&type=script&lang=js"

import "./LightboxRetention.vue?vue&type=style&index=0&id=802a6e36&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-802a6e36"]])

export default __exports__